var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayscale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200.000000pt",
    height: "601.000000pt",
    viewBox: "0 75 375 450",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,601.000000) scale(0.100000,-0.100000)",
    fill: "#747A7F",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2933 4870 c-95 -38 -173 -153 -173 -255 0 -95 66 -201 155 -248 61 -32 183 -31 249 3 93 48 147 140 145 249 -1 67 -14 105 -55 163 -66 93 -209 132 -321 88z",
    fill: "#B52C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2960 4081 c-73 -23 -145 -87 -176 -158 -24 -55 -23 -157 3 -214 44 -99 138 -160 247 -161 245 -1 369 290 196 462 -68 69 -180 98 -270 71z",
    fill: "#B52C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 3281 c-60 -21 -123 -75 -155 -136 -29 -53 -31 -183 -4 -232 90 -167 303 -206 435 -80 78 74 104 198 62 295 -30 70 -102 136 -171 156 -67 20 -101 20 -167 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183 3291 c-135 -35 -230 -178 -204 -309 28 -139 127 -222 266 -222 139 0 238 83 266 222 21 106 -37 226 -137 280 -55 30 -138 42 -191 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2963 3286 c-121 -40 -193 -133 -193 -252 0 -81 18 -129 67 -184 58 -65 115 -90 200 -90 143 1 253 98 270 239 12 104 -55 224 -150 270 -56 27 -141 34 -194 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 2501 c-78 -16 -155 -74 -193 -146 -31 -57 -31 -183 0 -241 26 -49 92 -110 142 -132 47 -20 155 -20 203 1 56 24 123 91 148 149 43 101 15 225 -69 301 -65 58 -152 84 -231 68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401 2499 c-123 -24 -221 -141 -221 -264 0 -55 28 -130 66 -173 126 -147 358 -121 451 51 25 46 25 188 0 238 -54 109 -178 171 -296 148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 2499 c-141 -27 -239 -175 -210 -316 23 -108 108 -191 220 -215 156 -32 316 103 314 266 -1 107 -56 197 -147 240 -62 29 -116 37 -177 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2980 2499 c-85 -16 -171 -96 -200 -182 -16 -51 -9 -152 15 -201 84 -174 322 -203 449 -54 38 43 66 118 66 173 0 166 -162 296 -330 264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 1684 c-202 -100 -201 -379 2 -487 58 -31 174 -31 232 0 59 31 103 79 132 142 21 45 24 64 20 120 -5 73 -22 112 -71 167 -73 84 -212 110 -315 58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 1684 c-81 -40 -138 -122 -149 -213 -19 -163 135 -317 298 -298 91 11 173 68 213 149 51 102 27 237 -55 315 -81 76 -209 96 -307 47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155 1698 c-34 -12 -91 -52 -118 -83 -65 -73 -80 -201 -34 -291 46 -91 146 -154 242 -154 55 0 130 28 173 66 149 127 120 365 -56 450 -44 21 -163 28 -207 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 1689 c-101 -45 -160 -138 -160 -250 0 -138 100 -249 239 -266 122 -14 252 73 286 191 38 130 -18 261 -137 320 -67 33 -161 35 -228 5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayscale);
export default __webpack_public_path__ + "static/media/Payscale.37118760.svg";
export { ForwardRef as ReactComponent };